import { useState, useEffect } from 'react';

/**
 * Custom hook สำหรับตรวจจับประเภทอุปกรณ์ (Desktop / Tablet / Mobile)
 * ใช้ทั้ง screen width และ userAgent เพื่อความแม่นยำ
 */
const useDevice = () => {
  const getDevice = () => {
    const width = window.innerWidth;
    const ua = navigator.userAgent || '';
    
    // ตรวจจาก User Agent ก่อน (แม่นยำกว่าสำหรับ mobile จริงๆ)
    const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    // iPad ที่ใช้ iPadOS จะรายงานตัวเองเป็น Mac ต้องตรวจ touch ด้วย
    const isTabletUA = /iPad/i.test(ua) || (navigator.maxTouchPoints > 1 && /Macintosh/i.test(ua));
    
    // ผสมกับ screen width เพื่อความยืดหยุ่น (responsive)
    if (width <= 768 || (isMobileUA && !isTabletUA)) {
      return 'mobile';
    }
    if ((width > 768 && width <= 1200) || isTabletUA) {
      return 'tablet';
    }
    return 'desktop';
  };

  const [device, setDevice] = useState(getDevice);

  useEffect(() => {
    let timeoutId;
    let orientationTimeoutId;

    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setDevice(getDevice());
      }, 150); // debounce 150ms
    };

    const handleOrientationChange = () => {
      clearTimeout(orientationTimeoutId);
      orientationTimeoutId = setTimeout(() => {
        setDevice(getDevice());
      }, 300);
    };

    window.addEventListener('resize', handleResize);
    // ตรวจจับ orientation change (มือถือหมุนจอ)
    window.addEventListener('orientationchange', handleOrientationChange);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleOrientationChange);
      clearTimeout(timeoutId);
      clearTimeout(orientationTimeoutId);
    };
  }, []);

  return {
    device,                         // 'mobile' | 'tablet' | 'desktop'
    isMobile: device === 'mobile',
    isTablet: device === 'tablet',
    isDesktop: device === 'desktop',
    isTouchDevice: device !== 'desktop',
  };
};

export default useDevice;
